/**
 * Constants for the JS Orchestrator
 */

// Import version directly from package.json
import packageJson from '../package.json';

export const VERSION = packageJson.version;

// Debug storage key
export const DEBUG_STORAGE_KEY = 'kaigentic-debug';

// Event listener cleanup timeouts
export const EVENT_CLEANUP_TIMEOUT = 100;

// Message processing timeouts
export const DEFAULT_MESSAGE_TIMEOUT = 10000; // 10 seconds
export const DEFAULT_MAX_RETRIES = 3;
export const MESSAGE_DEDUPE_WINDOW = 1000; // 1 second
export const MESSAGE_CLEANUP_THRESHOLD = 100;
export const MESSAGE_CLEANUP_CUTOFF_MULTIPLIER = 10;

// Request timeout for async operations
export const REQUEST_TIMEOUT = 100; // For injection operations

// Auto-initialization delay
export const AUTO_INIT_DELAY = 100;

// Validation constants
export const AGENT_NAME_PATTERN = /^[a-zA-Z0-9_-]+$/;

// Layout constraints
export const LAYOUT_CONSTRAINTS = {
  WIDTH_MIN: 200,
  WIDTH_MAX: 2000,
  HEIGHT_MIN: 300,
  HEIGHT_MAX: 2000,
  LAUNCHER_SIZE_MIN: 40,
  LAUNCHER_SIZE_MAX: 100,
  OFFSET_MIN: 0,
  OFFSET_MAX: 200,
  Z_INDEX_MIN: 1,
  Z_INDEX_MAX: 999999,
  Z_INDEX_WARNING_THRESHOLD: 9999,
  BORDER_RADIUS_MIN: 0,
  BORDER_RADIUS_MAX: 50,
} as const;

// Valid configuration values
export const VALID_POSITIONS = [
  'bottom-right',
  'bottom-left', 
  'top-right',
  'top-left',
  'center'
] as const;

export const VALID_THEMES = ['light', 'dark', 'auto'] as const;

export const VALID_SANDBOX_ATTRIBUTES = [
  'allow-downloads',
  'allow-downloads-without-user-activation',
  'allow-forms',
  'allow-modals',
  'allow-orientation-lock',
  'allow-pointer-lock',
  'allow-popups',
  'allow-popups-to-escape-sandbox',
  'allow-presentation',
  'allow-same-origin',
  'allow-scripts',
  'allow-storage-access-by-user-activation',
  'allow-top-navigation',
  'allow-top-navigation-by-user-activation',
  'allow-top-navigation-to-custom-protocols'
] as const;

export const VALID_REFERRER_POLICIES = [
  'no-referrer',
  'no-referrer-when-downgrade',
  'origin',
  'origin-when-cross-origin',
  'same-origin',
  'strict-origin',
  'strict-origin-when-cross-origin',
  'unsafe-url'
] as const;

// CSS class prefixes
export const CSS_CLASS_PREFIX = 'kaigentic-chat';
export const IFRAME_CLASS_PREFIX = `${CSS_CLASS_PREFIX}-iframe`;

// Mobile viewport breakpoint
export const MOBILE_BREAKPOINT = 768;

